import { render, staticRenderFns } from "./blackboardLights.vue?vue&type=template&id=5f373d2a&"
import script from "./blackboardLights.vue?vue&type=script&lang=js&"
export * from "./blackboardLights.vue?vue&type=script&lang=js&"
import style0 from "./blackboardLights.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports